module.exports = __webpack_public_path__ + "img/play-icon.02a58f31.svg";